import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";

const CancelToken = axios.CancelToken;
var source = CancelToken.source();

const types = [
    "TO_DO",
    "MINE",
    "MINE_APPRO",
    "MINE_REJ",
    "ALL",
    "OPEN",
    "FINAL",
    "REJECTED"
];

export const initialState = {
    loaded: false,
    type: null,
    to: JSON.stringify(new Date()),
    from: JSON.stringify(new Date()),
    vendor: null,
    requests: [],
    rawRequests: null
}

export const overviewdataSlice = createSlice({
    name: "appdata",
    initialState,
    reducers: {
        overviewdata_setLoaded: (state, action) => {
            state.loaded = action.payload;
        },
        overviewdata_setType: (state, action) => {
            state.type = action.payload
        },
        overviewdata_setFrom: (state, action) => {
            state.from = action.payload
        },
        overviewdata_setTo: (state, action) => {
            state.to = action.payload
        },
        overviewdata_setVendor: (state, action) => {
            state.vendor = action.payload
        },
        overviewdata_setRequests: (state, action) => {
            state.requests = action.payload
        },
        overviewdata_setRawRequests: (state, action) => {
            state.rawRequests = action.payload
        }
    }
})

export const {
    overviewdata_setLoaded,
    overviewdata_setType,
    overviewdata_setFrom,
    overviewdata_setTo,
    overviewdata_setVendor,
    overviewdata_setRequests,
    overviewdata_setRawRequests
} = overviewdataSlice.actions;

export const overviewdataSelector = state => state.overviewdata;

export default overviewdataSlice.reducer;


export function overview_fetchData() {


    return async (dispatch, getState) => {

        // always kill the current action. this is not good code practice.
        // source.cancel("Operation canceled by the user.");

        // create new source
        source = CancelToken.source();
        //console.log("set source");
        //console.log(source);
        const axiosConfig = {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
            cancelToken: source.token
        };


        let fromdate = new Date(JSON.parse(getState().overviewdata.from)).toLocaleDateString("de").replace("/", ".")
        let todate = new Date(JSON.parse(getState().overviewdata.to)).toLocaleDateString("de").replace("/", ".")

        axios
            .post(APPCONFIG.appBackendHostname + "api/vendormasterdata/requests", { type: types[getState().overviewdata.type], from: fromdate, to: todate, vendor: getState().overviewdata.vendor }, axiosConfig)
            .then(res => {
                console.log("data received, go resolve", res);
                let mapped = [];
                res.data.requests.map(value => {
                    mapped.push(value.DATA)
                })
                dispatch(overviewdata_setRequests(mapped))
                dispatch(overviewdata_setRawRequests(res.data.requests));
            })
            .catch(error => {
                console.log("error received", error);                    //reject(error);
            });


    }
}